module.exports = __webpack_public_path__ + "static/media/TimeAfterTime_Bookcover.2910e4d0.jpg";